import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { consumePostLoginPath } from "./postLoginPath";
export var PostLoginRedirect = function () {
    var navigate = useNavigate();
    var _a = useAuth(), isAuthenticated = _a.isAuthenticated, isLoadingAuth = _a.isLoadingAuth;
    var handledRef = useRef(false);
    useEffect(function () {
        if (isLoadingAuth) {
            return;
        }
        if (!isAuthenticated) {
            handledRef.current = false;
            return;
        }
        if (handledRef.current) {
            return;
        }
        var path = consumePostLoginPath();
        if (!path) {
            return;
        }
        handledRef.current = true;
        navigate(path, { replace: true });
    }, [isAuthenticated, isLoadingAuth, navigate]);
    return null;
};
